import { Accordion as MAccordion } from '@mantine/core';
import classes from './accordion.module.scss';
import { IconMinus, IconPlus } from '@tabler/icons-react';

export const Accordion = MAccordion.extend({
  classNames: {
    chevron: classes.chevron,
    root: classes.root,
    item: classes.item,
    control: classes.control,
    content: classes.content,
  },
});

Accordion.defaultProps = {
  chevron: (
    <>
      <IconPlus className={`${classes.icon} ${classes.iconPlus}`} />
      <IconMinus className={`${classes.icon} ${classes.iconMinus}`} />
    </>
  ),
};
